// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2X6ix","title":"FrontImage_title__2Vgjq"};